import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import mixpanel from "../utils/mixpanel";
import { useSelector } from "react-redux";

const usePageTiming = () => {
  const location = useLocation();
  const startTimeRef = useRef(Date.now());
  const prevPathRef = useRef(location.pathname);

  // 🔥 Pull user data from Redux
  const userData = useSelector((state) => state.userData);

  const userMeta = {
    email: userData?.email ?? null,
    school: userData?.school_data?.school_name ?? null,
    userId: userData?.id ?? null,
    userType: userData?.school_data?.user_type ?? null,
  };

  useEffect(() => {
    const now = Date.now();
    const duration = (now - startTimeRef.current) / 1000;
    const prevPath = prevPathRef.current;

    if (prevPath) {
      mixpanel.track("Time Spent on Page", {
        page: prevPath,
        duration,
        ...userMeta,
      });
    }

    startTimeRef.current = now;
    prevPathRef.current = location.pathname;

    return () => {
      const duration = (Date.now() - startTimeRef.current) / 1000;
      mixpanel.track("Time Spent on Page (Exit)", {
        page: location.pathname,
        duration,
        ...userMeta,
      });
    };
  }, [location.pathname]);
};

export default usePageTiming;
